// @ts-check
import {
  RATE_LIMIT_BUDGET_WINDOW_MINUTES,
  RATE_LIMIT_TIER_BURSTS,
  tierBurstBudgetEquivalent
} from '../../shared/rate-limit-tiers.js';

/**
 * Sentence appended to a tier budget's field hint so the burst ceiling is visible
 * in the form that sets the budget.
 *
 * @param {string} tier
 * @returns {string} Empty when the tier has no configured binding
 */
export function tierCeilingHint(tier) {
  const burst = RATE_LIMIT_TIER_BURSTS[tier];
  const equivalent = tierBurstBudgetEquivalent(tier);
  if (!burst || !equivalent) return '';
  return `Burst ceiling ${burst.limit}/${burst.periodSeconds}s caps this near `
    + `${equivalent} per ${RATE_LIMIT_BUDGET_WINDOW_MINUTES} min.`;
}

/**
 * Warning for a budget the burst ceiling will never let a caller reach.
 *
 * @param {string} tier
 * @param {string|number|null|undefined} value
 * @returns {string} Empty when the budget is reachable
 */
export function tierCeilingWarning(tier, value) {
  const burst = RATE_LIMIT_TIER_BURSTS[tier];
  const equivalent = tierBurstBudgetEquivalent(tier);
  if (!burst || !equivalent) return '';
  const requested = Number(value);
  if (!Number.isFinite(requested) || requested <= equivalent) return '';
  return `${requested} is above the burst ceiling. Callers are still denied past `
    + `${burst.limit} per ${burst.periodSeconds}s, so anything over about ${equivalent} `
    + 'has no effect until the binding is raised in wrangler.jsonc.';
}
